<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>维保检查</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableSn"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <!-- <el-button type="primary" @click="addRow()">添加</el-button> -->
                <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <el-table-column label="设备名称">
                        <template slot-scope="scope">
                            <span class="color5" >{{scope.row.equipName}}</span>
                        </template> 
                    </el-table-column>
                    <el-table-column label="型号规格">
                        <template slot-scope="scope">
                            <span>{{ scope.row.specifications }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="参数">
                        <template slot-scope="scope">
                        <span>{{ scope.row.parameter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="机器类型">
                        <template slot-scope="scope">
                        <span>{{scope.row.distributionName}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="最近一次检查">
                        <template slot-scope="scope">
                        <span>{{ scope.row.updateDate }}</span>
                        </template>
                    </el-table-column>
                     <!-- <el-table-column label="配电箱图片">
                         <template slot-scope="scope">
                            <el-image v-if="scope.row.thumbnailUrl!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="http+scope.row.thumbnailUrl" :preview-src-list="scope.row.srcList"></el-image>
                            <img v-else src="../../../assets//image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
                         </template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="400" >
                        <template slot-scope="scope">
                          <!-- <el-button size="mini" v-if="isMenuExit('pro:elebox:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                          <!-- <el-button size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                          <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                          <el-button size="mini" type="success" @click="history(scope.$index, scope.row)">检查记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增窗口 -->
        <!-- <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            :rules="rules"
            >
                <el-form-item label="位置描述：">
                    <el-input v-model="addForm.location" placeholder="请输入位置描述" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="序列号：" prop="sn">
                    <el-input v-model="addForm.sn" placeholder="请输入序列号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="配电箱图片:">
                <el-upload
                  class="avatar-uploader"
                  v-bind:action="uploadUrl1"
                  :headers="uploadHead1"
                  :data="{type:230}"
                  :show-file-list="false"
                  :on-success="handleIconSuccess"
                >
                  <img v-if="icon" :src="icon" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
                <el-form-item label="参数：">
                    <el-input v-model="addForm.parameter" placeholder="请输入参数" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="机器类型">
                  <el-select v-model="addForm.distributionType" >
                    <el-option
                        v-for="item in machineType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                    </el-select>
            </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addVis = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog> -->
        <!-- 二维码弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            tableSn:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            addVis:false,
            dialogTitle:'',
            labelPosition:'right',
            addForm:{
             id:'',
             projectId:'',
             sn:'',
             parameter:'',
             location:'',
             remarks:'',
             photoUrl:'',
             thumbnailUrl:'',
             distributionType:''
            },
            uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
            uploadHead1: {
                accessToken: util.session.get('token')
            },
            rules:{
                sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            icon:'',//配电箱图
            http:base.httpCtx,
            machineType:''
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            myHttp.getDistributionPage({
                equipName:this.tableSn,
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.distribution.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        list[i].thumbnailUrl = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?list[i].thumbnailUrl:''
                        list[i].srcList = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?[base.httpCtx+list[i].thumbnailUrl]:[]
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.distribution.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },

        //添加
        addRow(){
            this.addVis = true
            this.addForm.id = ''
            this.addForm.sn = ''
            this.addForm.parameter = ''
            this.addForm.location = ''
            this.addForm.remarks = ''
            this.addForm.distributionType = ''
            this.dialogTitle = '添加'
            this.icon=''
            this.zidian()
        },
        //编辑
        handleEdit(index,row){
            this.zidian()
            this.addVis = true
            this.addForm.id = row.id
            this.addForm.sn = row.sn
            this.addForm.parameter = row.parameter
            this.addForm.location = row.location
            this.addForm.remarks = row.remarks
            this.addForm.photoUrl =row.photoUrl
            this.addForm.thumbnailUrl =row.thumbnailUrl
            this.addForm.distributionType = row.distributionType
            this.dialogTitle = '修改',
             this.icon =row.thumbnailUrl && row.thumbnailUrl != '' ? base.httpCtx + row.thumbnailUrl: ''
        },
        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.delDistribution({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        //提交
        sumbitAddRow(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    //console.log(that.addForm.id)
                    if(that.addForm.id==''){
                        that.addForm.createBy = util.session.get('user').id
                        myHttp.createDistribution(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.addVis = false
                                    that.currentPage = 1
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }else{
                        that.addForm.updateBy = util.session.get('user').id
                        myHttp.modDistribution(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('修改成功')
                                    that.addVis = false
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }
                }
            })
        },

        //展示二维码
        erCode(index,row){
            this.codeVis = true
            var obj=  {
               type:2,
               snId:row.id,
               projectId:this.groupId,
               path:'/pages/equipCheck/equipCheck?snId='+row.id
              }
            this.codeUrl=JSON.stringify(obj)    
            // this.codeUrl = '/pages/equipCheck/equipCheck?snId='+row.sn
            this.codeTit = row.location
        },

        /**
         * 判断是否展示
         */
        isMenuExit(row){
            // var flag = util.common.filterBtnMenu(row)
            // return flag
            return true
        },
      //获取字典表
      zidian() {
            var that = this
            myHttp
              .getDictByType({
                type: 'distribution_type'
              })
              .then(function(resp) {
                if (resp.data.code == '200') {
                  var list = resp.data.data.dictList || []
                  that.machineType = list
                }
              })
          },
        /**
         * 获取历史记录
         */
        history(index,row){
            this.$router.push({ path: '/eleBoxHistory/'+row.id })
        },
          // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      console.log(res.data)
      this.addForm.photoUrl = res.data.savePhotoUrls
      this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
    },
    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
.avatar{
    width: 100%;
}
</style>

<style>
    @import '../../../assets/css/common.css'
</style>